import Component_Viewport_137f7bc5a53186cfecda2e52f6d37b19 from "../../../../content/examples/basic/viewport/Viewport";
import Devtool_Viewport_137f7bc5a53186cfecda2e52f6d37b19 from "!!@devtool/loader!../../../../content/examples/basic/viewport/Viewport";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Viewport_137f7bc5a53186cfecda2e52f6d37b19,
  Devtool_Viewport_137f7bc5a53186cfecda2e52f6d37b19,
  DevTool,
  React
};